
import React, { useEffect, useState } from "react";
import { object, bool, string } from "prop-types";
import useStorage from "../../../hook/useStorage";
import { postBookmark } from "../../utils/post-bookmark";
import BookmarkPopup from "../bookmark-popup";
import { PopoverElement } from "../../atoms/popover-element";
import "./bookmark-icon.m.css";

const BookmarkIcon = ({ showBookmark, storyObj, user_flag, socialShare=false }) => {
  const [op, setOp] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [checkUser] = useStorage();
  const [strIds, setStrIds] = useState([])
  const [alreadyBM, setAlreadyBM] = useState(true);
  const [isBMid, setIsBMid] = useState(false);
  const [wListed, setWlisted] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    } else {
      setTimeout(() => {
        const myIds = JSON.parse(localStorage.getItem("storyIds") || "[]");
        setStrIds(myIds)
        if (myIds.includes(storyObj.id) === true) {
          setIsBMid(true)
        }
      }, 1000)
      const listed = JSON.parse(window.localStorage.getItem("ipUser"));
      setWlisted(listed)
    }
  }, [])
  return (
    <React.Fragment>
      {/* code block for debugging popover
      <button style={{cursor:"pointer", color:"red"}} onClick={(e)=>{
        e.preventDefault()
deleteUserFlag("bm_user_flag")}}>ResetBM</button>*/}
      {!wListed && showBookmark && (checkUser && isBMid && alreadyBM ?
        <button styleName={`bookmark-btn ${socialShare ? "social-share" : ""}`}
        className="bookmark-btn"
          title="Poista tallennus"
          aria-label="Poista tallennus"
          onClick={(e) => {
            e.preventDefault();
            postBookmark(e, storyObj.id, false)
            setAlreadyBM(false)
          }}
        >
          <i className={`ri-bookmark-fill`} styleName="bookmark-fill"></i>
          {socialShare && <span styleName="btn-type-text" className="btn-type-text">Tallenna</span>}
        </button>
        :
        <button  styleName={`bookmark-btn ${socialShare ? "social-share" : ""}`}
        className="bookmark-btn"
          title={`${op ? "Tallenna artikkeli" : "Poista tallennus"}`}
          aria-label={`${op ? "Tallenna artikkeli" : "Poista tallennus"}`}
          onClick={(e) => {
            e.preventDefault();
            if (checkUser) {
              setOp(!op)
              postBookmark(e, storyObj.id, op)
              setShowPopup(false)
            } else {
              setShowPopup(true)
            }
          }}>
          {op ?
            <PopoverElement showContents={false} user_flag={user_flag} anchor="ri-bookmark-line" />
            :
            <PopoverElement user_flag={user_flag} anchor="ri-bookmark-fill" />}
          {socialShare && <span styleName="btn-type-text" className="btn-type-text">Tallenna</span>}
        </button>
      )}
      {showPopup ? <BookmarkPopup closePopup={() => setShowPopup(false)} feature={"save-article"} /> : ""}

    </React.Fragment>
  );
};
BookmarkIcon.propTypes = {
  showBookmark: bool,
  storyObj: object,
  user_flag: string
};
export { BookmarkIcon };
